import './../../src/Netinteractive/NoteBundle/public/js/note.js'
import './js/actions/grid_actions.js'
import './js/actions/history.js'
import './js/actions/remove_offer.js'
import './js/forms/addon.vue'
import './js/forms/address.vue.js'
import './js/forms/address_show.vue.js'
import './js/forms/assignTeam'
import './js/forms/assign_route_to_sorter.vue'
import './js/forms/bag.vue'
import './js/forms/basket.vue'
import './js/forms/brand.vue'
import './js/forms/change_password.vue'
import './js/forms/change_portions_or_components.vue.js'
import './js/forms/client_profile.vue.js'
import './js/forms/client_show.vue.js'
import './js/forms/company.vue'
import './js/forms/company_client.vue'
import './js/forms/company_show.vue.js'
import './js/forms/component.vue'
import './js/forms/default_days.vue'
import './js/forms/dictionary.vue'
import './js/forms/diet_form.vue'
import './js/forms/discount_code_form.vue.js'
import './js/forms/drivers_report.vue.js'
import './js/forms/employee_profile.vue.js'
import './js/forms/featureflag.vue'
import './js/forms/global_price_list.vue'
import './js/forms/history.vue'
import './js/forms/history.vue.js'
import './js/forms/invoice_verify.vue'
import './js/forms/kitchen_report_summary.vue.js'
import './js/forms/limit.vue'
import './js/forms/material.vue'
import './js/forms/meal.vue'
import './js/forms/mealtype.vue'
import './js/forms/member_get_member.vue'
import './js/forms/menuPlanner.vue'
import './js/forms/menuPlannerSelect.vue'
import './js/forms/mobile_version.vue'
import './js/forms/non_default_day.vue'
import './js/forms/offer.vue'
import './js/forms/offer_import.vue'
import './js/forms/old_assign_team.vue'
import './js/forms/order_form.vue'
import './js/forms/overproduction.vue'
import './js/forms/package_form.vue'
import './js/forms/plan_generate.vue'
import './js/forms/price_list.vue'
import './js/forms/product.vue'
import './js/forms/production_list.vue'
import './js/forms/production_list_report.vue'
import './js/forms/purchaseOrderMaterials'
import './js/forms/purchase_material_report.vue'
import './js/forms/purchase_order.vue'
import './js/forms/purchase_order_materials.vue'
import './js/forms/purchase_order_show.vue'
import './js/forms/push.vue.js'
import './js/forms/rating_report.vue.js'
import './js/forms/region.vue'
import './js/forms/region_grid.vue'
import './js/forms/region_import.vue'
import './js/forms/register.vue'
import './js/forms/role.vue'
import './js/forms/route.vue'
import './js/forms/route_grid.vue'
import './js/forms/route_mismatch_quote_form.vue'
import './js/forms/serving_component.vue'
import './js/forms/serving_final.vue'
import './js/forms/size.vue'
import './js/forms/supplier.vue'
import './js/forms/team.vue'
import './js/forms/test.vue'
import './js/forms/user.vue'
import './js/forms/user_history.vue'
import './js/forms/variant.vue'
import './js/forms/verify_day.vue'
import './js/forms/warehouse.vue'
import './js/forms/warehouse_shift.vue'
import './js/forms/warehouse_stocks.vue'
import './js/forms/warehouse_warehouseman.vue'
import './js/forms/warehouse_work_order.vue.js'
import './js/forms/withdrawal.vue'
import './js/reports/control_report.vue.js'
import './js/reports/fiscalization_report.vue.js'
import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'
import './js/forms/speedeoAssigningCoordinatesAreas'
import './js/forms/overproduction'
import './js/forms/importPpkForBags'
import './js/forms/importD365'
import './js/forms/jobManagement/job_management.vue.js'
import './js/forms/warehouse_work_order_new.vue'
import './js/forms/unfolding_report_summary.vue.js'
import './js/forms/badge.vue.js'

try {
  const { release } = require('./../release.json')
  const { dsn, environment, tracesSampleRate } = require('./../sentry.json')

  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate,
    integrations: [new BrowserTracing()],
  })

  window.onerror = (message, source, lineno, colno, error) => {
    Sentry.captureException(error)
  }
} catch (exception) {
  console.info('Sentry is disabled, because config files are not present.')
}

$(document).ready(() => {
  $('.nav-toggle').removeAttr('href')
})
